import {css, Icon, view} from '@sail/ui/deprecated';
import {useTheme} from '../ThemeProvider';
import {useUniversalHelpDotComDesign} from '../FeatureFlagsProvider';

type Props = {
  size?: string;
  borderRadius?: string;
};

export const StripeAvatar = ({size = '28px', borderRadius = '50%'}: Props) => {
  const theme = useTheme();
  const useDotComDesign = useUniversalHelpDotComDesign();

  if (useDotComDesign) {
    return null;
  }

  return (
    <view.div data-testid="stripe-avatar" role="avatar">
      <Icon
        icon={theme.icon}
        css={{
          width: css.value(size),
          height: css.value(size),
          borderRadius: css.value(borderRadius),
        }}
      />
    </view.div>
  );
};

export default StripeAvatar;
